import {toast} from 'react-toastify';
import {t} from '@lingui/core/macro';

export interface ICheckNowToast {
    type: 'success' | 'error',
    message: string,
}

interface ICheckNowResponse {
    status?: string | boolean,
    message?: string,
}

const asResponse = (source: unknown): ICheckNowResponse => (
    typeof source === 'object' && source !== null ? source as ICheckNowResponse : {}
);

const getBackendMessage = (source: unknown): string => {
    if (typeof source === 'string') {
        return source.trim();
    }

    if (source instanceof Error) {
        return source.message.trim();
    }

    return asResponse(source).message?.trim() ?? '';
};

export const getCheckNowToast = (source: unknown): ICheckNowToast => {
    const {status} = asResponse(source);

    if (typeof status === 'string' && status) {
        return {
            type: 'success',
            message: t`Проверка отправлена, результат появится после обновления данных`,
        };
    }

    return {
        type: 'error',
        message: getBackendMessage(source) || t`Не удалось отправить проверку, попробуйте позже`,
    };
};

export const showCheckNowToast = (source: unknown): void => {
    const {type, message} = getCheckNowToast(source);

    if (type === 'success') {
        toast.info(message);
        return;
    }

    toast.warning(message);
};
